import type { CSSProperties } from "react";
import styles from "./CardsIntro.module.css";
import type { StageIntroVariantProps } from "./types";

/** Pattern A: three tall cards dealt onto the table. */
export default function CardsIntro({ stageLabel, conditions }: StageIntroVariantProps) {
  return (
    <section className={styles.wrap}>
      <header className={styles.header}>
        <small>{stageLabel}</small>
        <h2>この3つに近い英単語を探そう</h2>
      </header>
      <ol className={styles.cards}>
        {conditions.map((condition, index) => (
          <li key={condition.id} className={styles.card} style={{ "--power": condition.color, "--i": index } as CSSProperties}>
            <span className={styles.label}>{String(index + 1).padStart(2, "0")} · {condition.label}</span>
            <span className={styles.name}>{condition.name}</span>
            <strong className={styles.word} lang="en">{condition.text}</strong>
            <span className={styles.gloss}>{condition.gloss}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
